export default build =>
    build.query({
        tagTypes: ['allCenters'],
        keepUnusedDataFor: 1,
        query() {
            
            //console.log("payload",payload)            
            return {
                url: '/result/getAllCentersTse',
                method: 'GET',
                //body: payload,
            };
           
        },
       providesTags: ['allCentersTse']
    })
